export default __webpack_public_path__ + "static/media/car.4c51a754.png";